<template>
  <div class="h-full w-full flex justify-center">
    <div class="p-8 w-[24rem] md:w-[32rem]">
      <form @submit.prevent="submit()">
        <div class="grid space-y-2">
          <div>
            <input
              v-model="$store.state.form.first_name"
              :required="true"
              :placeholder="__('label_firstname')"
              name="first_name"
              class="w-full h-12 border border-gray-300"
              type="text"
            >

            <ErrorMessage name="first_name" />
          </div>

          <div>
            <input
              v-model="$store.state.form.last_name"
              :required="true"
              :placeholder="__('label_lastname')"
              name="last_name"
              class="w-full h-12 border border-gray-300"
              type="text"
            >

            <ErrorMessage name="last_name" />
          </div>

          <div>
            <input
              v-model="$store.state.form.email"
              :required="true"
              :placeholder="__('label_email')"
              name="email"
              class="w-full h-12 border border-gray-300"
              type="email"
            >

            <ErrorMessage name="email" />
          </div>

          <div v-if="dateOfBirthEnabled">
            <input
              id="date"
              v-model="$store.state.form.birth_date"
              :required="true"
              name="birth_date"
              class="w-full h-12 border border-gray-300 textbox-n"
              :min="moment(Date.now()).subtract(91, 'years').format('YYYY-MM-DD')"
              :max="moment(Date.now()).subtract(18, 'years').format('YYYY-MM-DD')"
              :placeholder="__('label_birthdate')"
              type="date"
            >

            <ErrorMessage name="birth_date" />
          </div>

          <div v-if="genderEnabled">
            <select
              v-model="$store.state.form.gender"
              :required="true"
              name="gender"
              class="w-full h-12 border border-gray-300"
            >
              <option
                value=""
                disabled
              >
                {{ __('label_gender') }}
              </option>
              <option value="male">
                {{ __('label_male') }}
              </option>
              <option value="female">
                {{ __('label_female') }}
              </option>
            </select>

            <ErrorMessage name="gender" />
          </div>

          <div v-if="postcodeEnabled">
            <input
              v-model="$store.state.form.postcode"
              :required="true"
              :placeholder="__('label_postcode')"
              name="postcode"
              class="w-full h-12 border border-gray-300"
              type="text"
            >

            <ErrorMessage name="postcode" />
          </div>

          <div>
            <div class="flex">
              <input
                v-model="$store.state.form.terms_accepted"
                :required="true"
                name="terms_accepted"
                class="rounded-md mt-2 h-6 w-6 border-gray-300"
                :style="{
                  'backgroundColor': $store.state.form.terms_accepted ? `#${config.style?.primary}` : '#ffffff',
                }"
                type="checkbox"
              >

              <p class="w-full ml-2 text-xs text-white">
                {{ __('lander_003_text_terms') }}
              </p>
            </div>

            <ErrorMessage name="terms_accepted" />
          </div>
        </div>

        <div class="py-2">
          <button
            class="w-full p-4 text-xl text-white font-black"
            :class="{
              'cursor-not-allowed': !canSubmit,
              'cursor-pointer': canSubmit,
            }"
            :style="{
              backgroundColor: canSubmit ? `#${config.style?.primary}` : '#cccccc',
            }"
          >
            {{ __('lander_003_form_submit') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import moment from 'moment';
import ErrorMessage from '@timon/js/Components/ErrorMessage.vue';
import {ref} from 'vue';

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },

  quizConfig: {
    type: Object,
    required: true,
  },

  canSubmit: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['submit']);

const dateOfBirthEnabled = ref(props.quizConfig.date_of_birth_enabled !== false);
const genderEnabled = ref(props.quizConfig.gender_enabled !== false);
const postcodeEnabled = ref(props.quizConfig.postcode_enabled !== false);

function submit() {
  if (!props.canSubmit) {
    return;
  }

  emit('submit');
}
</script>
